import { render } from "./Sync1328Component.vue?vue&type=template&id=3548cabd&scoped=true"
import script from "./Sync1328Component.vue?vue&type=script&lang=js"
export * from "./Sync1328Component.vue?vue&type=script&lang=js"

import "./Sync1328Component.vue?vue&type=style&index=0&id=3548cabd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3548cabd"]])

export default __exports__